export default __webpack_public_path__ + "static/media/arrow.970ce3c8.svg";